import React from 'react';
import { features } from '../data/content';
import * as Icons from 'lucide-react';

const FeaturesSection = () => {
  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'text-blue-600',
      green: 'text-green-600',
      purple: 'text-purple-600',
      orange: 'text-orange-600'
    };
    return colorMap[color] || 'text-blue-600';
  };

  return (
    <section id="platform" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-800/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-6">Revolutionary AI Orchestration</h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Unlike tools that assist coding, HiveCluster evolves projects autonomously through corporate-structured AI meetings.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => {
            const IconComponent = Icons[feature.icon];
            return (
              <div key={index} className="bg-slate-800 border border-slate-700 rounded-2xl p-8 hover:border-slate-600 transition-all duration-200 group">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <IconComponent className={`h-8 w-8 ${getColorClasses(feature.color)} group-hover:scale-110 transition-transform duration-200`} />
                  </div>
                  <div>
                    <div className="flex items-center space-x-3 mb-3">
                      <h3 className="text-xl font-semibold text-white">{feature.title}</h3>
                      <span className="bg-gradient-to-r from-green-500 to-blue-500 text-white px-3 py-1 rounded-full text-xs font-medium">
                        {feature.status}
                      </span>
                    </div>
                    <p className="text-slate-300 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
